// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/scss/core/print.scss
// module id = 4732
// module chunks = 50